import React, { useContext, useEffect, useState } from 'react';
import { occasionList_fr,occasionList_ar,occasionList_en,occasionList_km } from '../utils/occasions.js';
import { AppContext } from '../../../AppContextProvider.jsx';

export function OccasionPicker({ value, onChange, className = '' }) {
  const [occasionList,setOccasionList] = useState(occasionList_fr);
  const [AppState,setAppState]  = useContext(AppContext);
  useEffect(()=>{
      if(AppState.settings.lang==="fr")
        setOccasionList(occasionList_fr);
      else if(AppState.settings.lang==="ar")
        setOccasionList(occasionList_ar);
      else if(AppState.settings.lang==="en")
        setOccasionList(occasionList_en);
      else if(AppState.settings.lang==="km" || AppState.settings.lang==="sw")
        setOccasionList(occasionList_km);
  },[AppState.settings.lang]) 
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }} className={className}>
      {occasionList.map((occ) => (
        <button
          key={occ.id}
          type="button"
          onClick={() => onChange(occ.id)}
          style={{
            border: value === occ.id ? '0.5px solid #1a1a2e' : '0.5px solid #d1d5db',
            borderRadius: 20,
            padding: '6px 14px',
            fontSize: 13,
            cursor: 'pointer',
            background: value === occ.id ? '#1a1a2e' : 'transparent',
            color: value === occ.id ? '#e8e0f0' : 'inherit',
            fontFamily: 'inherit',
            display: 'flex',
            alignItems: 'center',
            gap: 5,
            transition: 'all 0.15s',
          }}
        >
          <span role="img" aria-hidden="true">{occ.emoji}</span>
          {occ.label}
        </button>
      ))}
    </div>
  );
}

export default OccasionPicker;
